module.exports = __webpack_public_path__ + "img/pdflogo.76c58850.png";